import type { UserClassification } from '@bliks-io/contracts';

/**
 * Who may hold a process-level role: everyone.
 *
 * The owner moderates the process and records on behalf of its external
 * contacts, who cannot sign in — neither depends on being inside the org, so
 * external members qualify. Named so every site that widens a picker beyond
 * `UserSelect`'s internal-only default is greppable, and so the wizard and the
 * process form cannot drift apart.
 *
 * NOT for step performers: those are the org's own work and stay internal.
 */
export const PROCESS_ROLE_CLASSIFICATIONS: readonly UserClassification[] = [
  'internal',
  'external'
] as const;
